module.exports = require("./az-Cyrl-AZ.js");